import config from '@/modules/config/functions/config';
import PWAManager from '@/modules/core/components/pwa-manager';
import RouterProvider from '@/modules/core/components/router-provider';
import getQueryClient from '@/modules/query-client/functions/getQueryClient';
import { Helmet, HelmetProvider } from '@dr.pogodin/react-helmet';
import * as Sentry from '@sentry/react';
import { QueryClientProvider } from '@tanstack/react-query';
import { PatternsProvider } from '@thisisdmg/tirecloud-patterns/v2';
import { useTranslation } from 'react-i18next';

const tanstackQueryClient = getQueryClient();

/**
 * App component
 * @returns App component
 */
export default function App() {
  const { i18n } = useTranslation();

  return (
    <Sentry.ErrorBoundary>
      <PWAManager
        currentVersion={import.meta.env.REACT_APP_CHROMIUM_LIKE_VERSION}
        enabled
      >
        <HelmetProvider>
          <Helmet>
            <html data-theme="light" lang={i18n.language} dir={i18n.dir()} />
            <title>
              {config(
                `app.name.${i18n.language}`,
                config('app.name.__default__', 'TireCloud<wbr/>.One')
              ).replace(/<wbr\s*\/>/g, '')}
            </title>
          </Helmet>
          <PatternsProvider direction={i18n.dir()} themeMode="light">
            <QueryClientProvider client={tanstackQueryClient}>
              <RouterProvider />
            </QueryClientProvider>
          </PatternsProvider>
        </HelmetProvider>
      </PWAManager>
    </Sentry.ErrorBoundary>
  );
}
